import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import {
  faEye,
  faEyeSlash,
  faSpinner
} from '@fortawesome/free-solid-svg-icons';

export default function LoginGral() {
  const [form, setForm] = useState({ correo: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // ← estado para el spinner
  const [showPassword, setShowPassword] = useState(false); // ← estado para mostrar/ocultar password

  const { login, loginWithGoogle } = useAuth();

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true); // ← activa el spinner

    try {
      const loginResult = await login(form.correo, form.password);
      const rol = loginResult?.user?.rol;

      if (rol === 'user') navigate('/user/home');
      else if (rol === 'doctor') navigate('/doctor/home');
      else if (rol === 'admin') navigate('/admin/dashboard');
      else setError('Rol de usuario desconocido');

    } catch (err) {if (!err.response) {
          setError('Error al iniciar sesión. Por favor, intenta más tarde.');
        } else {
          setError(err.response.data?.message || 'Error-f');
        }
    } finally {
      setLoading(false); // ← desactiva el spinner
    }
  };


  return (
    <div className="min-h-screen flex justify-center items-start pt-10">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md flex flex-col gap-4">
          <h2 className="text-xl font-bold mb-4 text-center">Iniciar Sesión</h2>

          <label className="block">Correo</label>
          <input
            type="email"
            name="correo"
            placeholder="Correo"
            value={form.correo}
            onChange={handleChange}
            required
            className="w-full p-2 border rounded mb-2"
          />

          <label className="block">Contraseña</label>
          <div className="relative mb-2">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="contraseña"
              value={form.password}
              onChange={handleChange}
              required
              className="w-full p-2 border rounded pr-10"
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-2.5 cursor-pointer text-gray-600"
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </span>
          </div>

          {error && <p className="text-red-600 mb-4 text-sm">{error}</p>}

          <button
            type="submit"
            className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700 flex items-center justify-center"
            disabled={loading}
          >
            {loading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
                Iniciando sesión...
              </>
            ) : (
              'Iniciar Sesión'
            )}
          </button>

          {/* Línea con OR */}
          <div className="flex items-center my-2">
            <hr className="flex-grow border-gray-300" />
            <span className="mx-2 text-gray-500 text-sm">o</span>
            <hr className="flex-grow border-gray-300" />
          </div>

          {/* Botón Google con mismo ancho que el botón de Entrar */}
          <div className="w-full">
            <div className="w-full flex justify-center">
            <GoogleLogin
              width="100%" // esto depende del componente, puedes ajustar o envolver si no se aplica
              onSuccess={async (credentialResponse) => {
                try {
                  const result = await loginWithGoogle(credentialResponse);
                  
                  const rol = result.user?.rol;
                  if (rol === 'user') navigate('/user/home');
                  else if (rol === 'doctor') navigate('/doctor/home');
                  else if (rol === 'admin') navigate('/admin/dashboard');
                } catch (err) {
                  setError('Error con inicio de sesión de Google');
                }
              }}
              onError={() => {
                setError('Fallo el inicio de sesión con Google');
              }}
              useOneTap
            />
          </div>
          </div>

          <div className="text-center mt-4">
            <p className="text-blue-600 text-sm cursor-pointer hover:underline" onClick={() => navigate('/solicitud-recuperar')}>
              ¿Olvidaste tu contraseña? Recupérala aquí
            </p>
          </div>
      </form>
    </div>

  );
}
